import moment from 'moment';
import reportingAccTemplate from './reportingAccountsTable.html';
import { NON_MOVEMENT_ACCOUNTS } from '../../../../services/arsweb/TableTitles';

export function reportingAccountsTable() {
    return {
        restrict: 'E',
        scope: {
            tableId: '@'
        },
        templateUrl: reportingAccTemplate,
        controller: ReportingAccountsTableController,
        controllerAs: 'vm'
    };
}

export class ReportingAccountsTableController {
    constructor($scope, userService, arsMainDependencies) {
        this.$scope = $scope;
        this.state = arsMainDependencies.$state;
        this.translate = userService.fsMainDependencies.$translate;
        this.radioDateValue = 'radioDate';
        this.days = [
                       { label: `10 ${this.translate.instant('DAYS')}`,   value: 10 },
                       { label: `1 ${this.translate.instant('MONTH')}`,  value: 30 },
                       { label: `3 ${this.translate.instant('MONTHS')}`, value: 90 }
                    ];
        this.selectedType = this.days[1].value;
        this.pickedDate = new Date();
        this.predefinedQuery = { predefinedQuery: NON_MOVEMENT_ACCOUNTS, dateFrom: this.todayMinus(this.selectedType) };
    }

    dateChange(value) {
        this.pickedDate = moment(this.pickedDate);
        this.$scope.$broadcast('predefinedQuery', { predefinedQuery: NON_MOVEMENT_ACCOUNTS, dateFrom: value ? this.todayMinus(value) : this.pickedDate });
    }

    selectRadioButton(value) {
        this.selectedType = value;
        this.dateChange();
    }

    resetRadioDate() {
        this.pickedDate = new Date();
        this.selectedType = this.radioDateValue;
        this.dateChange();
    }

    todayMinus(value) {
        const date = new Date();
        date.setDate(date.getDate() - value);
        return date;
    }
}
